import { createContext } from "react"

const Time = createContext()

export default Time
